/**  Тип ошибки приложения. */
export enum AppErrorTypes {
  /** Нет ошибки.*/
  None = "",

  /** Технические работы на сервере. */
  TechnicalWorks = "TechnicalWorks",

  /** Технические работы на сервере. */
  Offline = "Offline",

  /** Технические работы на сервере. */
  UnsupportedBrowser = "UnsupportedBrowser",

  /** Непредвиденная ошибка. */
  UnexpectedError = "UnexpectedError",

  /** Ошибка неактуальности версии клиента. */
  ClientIsOutdatedError = "ClientIsOutdatedError"
}
